module.exports = __webpack_public_path__ + "static/media/SG.c4e35867.png";